module.exports = __webpack_public_path__ + "img/Wai View 2.97d4bae1.png";